import React, { useState } from 'react'
import clsx from 'clsx'
import { MarkdownContent } from '@/components/organisms/MarkdownContent/MarkdownContent'
import { ReleaseAccordionPropTypes } from './types'
import * as styles from './ReleaseAccordion.module.css'

export function ReleaseAccordion({ release_excerpt, release_body }: ReleaseAccordionPropTypes) {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => setIsOpen((prev) => !prev)

  return (
    <div className={styles.releaseWrapper}>
      <MarkdownContent content={release_excerpt} />
      {isOpen && <MarkdownContent content={release_body} />}
      <button type="button" aria-labelledby="open-release" className="text-left flex" onClick={toggleOpen}>
        <h4 className="text-primary-500 font-bold text-bodyM">{isOpen ? 'Hide' : 'Read more'}</h4>
        <span className="ml-8">
          <i className={clsx('text-primary-500', isOpen ? 'fa fa-chevron-up' : 'fa fa-chevron-down')} />
        </span>
      </button>
    </div>
  )
}
